import React from 'react'
import { Link } from 'react-router-dom'
import { BaseView, baseStateToProps } from '../smart_bps/lib/base_view'
import { wrapView } from '../smart_bps/lib/utils'
import { AuthorizedDropDownMeny, UnauthorizedDropDownMenu } from '../lib/NavDropdownMenu'
import { REQUEST_CONTROL_PATH } from './constants'

class ReportsHub extends BaseView {
  renderBreadcrumbs() {
    return (
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Домой</Link>
          </li>
          <li className="breadcrumb-item active">Отчёты</li>
        </ol>
      </nav>
    )
  }

  renderTopPanelRightItems() {
    if (this.authorized) {
      return (
        <AuthorizedDropDownMeny
          userTitle={this.user_title}
          onLogout={this.logout}
        />
      )
    }
    return <UnauthorizedDropDownMenu />
  }

  renderContent() {
    return (
      <div className="sigur-hero__quick">
          <div className="sigur-hero__grid">
            <Link
              to={`/reports/${REQUEST_CONTROL_PATH}`}
              className="sigur-hero__card"
            >
              <i className="ti ti-chart-bar sigur-hero__card-icon" />
              <div className="sigur-hero__card-body">
                <span className="sigur-hero__card-title">Контроль заявок</span>
                <span className="sigur-hero__card-desc">
                  Сводка и детализация заявок по контрагентам, территориям и
                  итогам согласования
                </span>
              </div>
              <i className="ti ti-chevron-right sigur-hero__card-arrow" />
            </Link>
          </div>
      </div>
    )
  }
}

export default wrapView(ReportsHub, baseStateToProps)
